import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import { useAtomValue } from 'jotai';
import { useState } from 'react';
import { GenericFallbacksWrapper } from '../../../../../components/Fallback/GenericFallbacksWrapper';
import { milestonesByCompanyStateLoadableJ } from '../../../../../services/state/MilestonesStateJ';
import { SubSection } from '../../../Summary/components/SubSection';
import { MilestoneModal } from '../MilestoneForms/MilestoneModal';
import { selectedCompanyIdProfileAtom } from '../../../state/UIStateJ';
import { Milestones } from './Milestones';

export const MilestonesSection = () => {
  const companyId = useAtomValue(selectedCompanyIdProfileAtom);

  const milestones = useAtomValue(milestonesByCompanyStateLoadableJ(companyId));
  const [showModal, setShowModal] = useState(false);

  return (
    <SubSection
      title='Milestones'
      actionComponent={
        <Button
          color={'secondary'}
          endIcon={<AddIcon />}
          onClick={() => setShowModal(true)}
          variant={'outlined'}
          sx={{ marginLeft: 'auto' }}
        >
          Add milestone
        </Button>
      }
      noCard={milestones.state !== 'hasData' || !milestones.data?.length}
      cardPadding={'.75rem .7rem'}
      collapseProps={{ collapsible: true, defaultExpanded: true }}
    >
      <GenericFallbacksWrapper>
        <MilestoneModal open={showModal} onClose={() => setShowModal(false)} />
        <Milestones />
      </GenericFallbacksWrapper>
    </SubSection>
  );
};
